var path = 'src/app/patients/plasmapheresis/plasmapheresis.html';
var html = "<h1 class=page-header>Plasmapheresis</h1> <div plasmapheresis-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/plasmapheresis/plasmapheresis.html
 ** module id = 555
 ** module chunks = 0
 **/